import { extendTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import cssVarJson from './export.json';
import { fixThemeOptions } from '../../utils/theme';
import ProximaNovaBlack from './fonts/proxima-nova/proxima_nova_black.woff';
import ProximaNovaBlack2 from './fonts/proxima-nova/proxima_nova_black.woff2';
import ProximaNovaBlackItalic from './fonts/proxima-nova/proxima_nova_black_italic.woff';
import ProximaNovaBlackItalic2 from './fonts/proxima-nova/proxima_nova_black_italic.woff2';
import ProximaNovaBold from './fonts/proxima-nova/proxima_nova_bold.woff';
import ProximaNovaBold2 from './fonts/proxima-nova/proxima_nova_bold.woff2';
import ProximaNovaBoldItalic from './fonts/proxima-nova/proxima_nova_bold_italic.woff';
import ProximaNovaBoldItalic2 from './fonts/proxima-nova/proxima_nova_bold_italic.woff2';
import ProximaNovaExtrabold from './fonts/proxima-nova/proxima_nova_extrabold.woff';
import ProximaNovaExtrabold2 from './fonts/proxima-nova/proxima_nova_extrabold.woff2';
import ProximaNovaLight from './fonts/proxima-nova/proxima_nova_light.woff';
import ProximaNovaLight2 from './fonts/proxima-nova/proxima_nova_light.woff2';
import ProximaNovaRegular from './fonts/proxima-nova/proxima_nova_regular.woff';
import ProximaNovaRegular2 from './fonts/proxima-nova/proxima_nova_regular.woff2';
import ProximaNovaRegularItalic from './fonts/proxima-nova/proxima_nova_regular_italic.woff';
import ProximaNovaRegularItalic2 from './fonts/proxima-nova/proxima_nova_regular_italic.woff2';
import ProximaNovaSemibold from './fonts/proxima-nova/proxima_nova_semibold.woff';
import ProximaNovaSemibold2 from './fonts/proxima-nova/proxima_nova_semibold.woff2';
import ProximaNovaThin from './fonts/proxima-nova/proxima_nova_thin.woff';
import ProximaNovaThin2 from './fonts/proxima-nova/proxima_nova_thin.woff2';
import ProximaNovaThinItalic from './fonts/proxima-nova/proxima_nova_thin_italic.woff';
import ProximaNovaThinItalic2 from './fonts/proxima-nova/proxima_nova_thin_italic.woff2';
import PoppinsBold from './fonts/poppins/poppins_bold.ttf';
import PoppinsBoldItalic from './fonts/poppins/poppins_bold_italic.ttf';
import PoppinsItalic from './fonts/poppins/poppins_italic.ttf';
import PoppinsRegular from './fonts/poppins/poppins_regular.ttf';
const CSS_VAR_PREFIX = 'hcp'; // Needs to be unique to support theme nesting
const baseFontFamily = 'Proxima Nova, Helvetica, Arial, sans-serif';
const customizations = {
    cssVarPrefix: CSS_VAR_PREFIX,
    breakpoints: {
        values: {
            xs: 0,
            sm: 768,
            md: 998,
            lg: 1280,
            xl: 1920,
        },
    },
    typography: {
        fontFamily: baseFontFamily,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
        @font-face {
          font-family: 'Proxima Nova';
          font-weight: 900;
          src: url(${ProximaNovaBlack2}) format('woff2'), url(${ProximaNovaBlack}) format('woff');
          font-display: auto;
          font-style: normal;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Proxima Nova';
          font-weight: 900;
          src: url(${ProximaNovaBlackItalic2}) format('woff2'), url(${ProximaNovaBlackItalic}) format('woff');
          font-display: auto;
          font-style: italic;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Proxima Nova';
          font-weight: 800;
          src: url(${ProximaNovaExtrabold2}) format('woff2'), url(${ProximaNovaExtrabold}) format('woff');
          font-display: auto;
          font-style: normal;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Proxima Nova';
          font-weight: 700;
          src: url(${ProximaNovaBold2}) format('woff2'), url(${ProximaNovaBold}) format('woff');
          font-display: auto;
          font-style: normal;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Proxima Nova';
          font-weight: 700;
          src: url(${ProximaNovaBoldItalic2}) format('woff2'), url(${ProximaNovaBoldItalic}) format('woff');
          font-display: auto;
          font-style: italic;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Proxima Nova';
          font-weight: 600;
          src: url(${ProximaNovaSemibold2}) format('woff2'), url(${ProximaNovaSemibold}) format('woff');
          font-display: auto;
          font-style: normal;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Proxima Nova';
          font-weight: 400;
          src: url(${ProximaNovaRegular2}) format('woff2'), url(${ProximaNovaRegular}) format('woff');
          font-display: auto;
          font-style: normal;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Proxima Nova';
          font-weight: 400;
          src: url(${ProximaNovaRegularItalic2}) format('woff2'), url(${ProximaNovaRegularItalic}) format('woff');
          font-display: auto;
          font-style: italic;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Proxima Nova';
          font-weight: 300;
          src: url(${ProximaNovaLight2}) format('woff2'), url(${ProximaNovaLight}) format('woff');
          font-display: auto;
          font-style: normal;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Proxima Nova';
          font-weight: 100;
          src: url(${ProximaNovaThin2}) format('woff2'), url(${ProximaNovaThin}) format('woff');
          font-display: auto;
          font-style: normal;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Proxima Nova';
          font-weight: 100;
          src: url(${ProximaNovaThinItalic2}) format('woff2'), url(${ProximaNovaThinItalic}) format('woff');
          font-display: auto;
          font-style: italic;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Poppins';
          font-weight: 400;
          src: url(${PoppinsRegular}) format('truetype');
          font-display: auto;
          font-style: normal;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Poppins';
          font-weight: 400;
          src: url(${PoppinsItalic}) format('truetype');
          font-display: auto;
          font-style: italic;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Poppins';
          font-weight: 700;
          src: url(${PoppinsBold}) format('truetype');
          font-display: auto;
          font-style: normal;
          font-stretch: normal;
        }

        @font-face {
          font-family: 'Poppins';
          font-weight: 700;
          src: url(${PoppinsBoldItalic}) format('truetype');
          font-display: auto;
          font-style: italic;
          font-stretch: normal;
        }
      `,
        },
        // Temporary fixes to the export. Once the figma is fixed and exported properly, these should be removed
        MuiButton: {
            styleOverrides: {
                sizeLarge: ({ ownerState }) => ({
                    // Export bug causing variant outlined hover padding change
                    padding: ownerState.variant === 'text' ? '8px 11px' : '8px 22px',
                    '&.Mui-disabled': {
                        padding: ownerState.variant === 'text' ? '8px 11px' : '8px 22px',
                    },
                    // MUI export sets default widths for the ripple effect, partly showing it when not interacting with the button
                    '&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover) .MuiTouchRipple-root': {
                        width: '0 !important',
                    },
                    ':hover': {
                        padding: ownerState.variant === 'text' ? '8px 11px' : '8px 22px', // Export bug causing button hover padding change
                    },
                }),
                sizeMedium: ({ ownerState }) => ({
                    // Export bug causing variant outlined hover padding change
                    padding: ownerState.variant === 'text' ? '6px 8px' : '6px 16px',
                    '&.Mui-disabled': {
                        padding: ownerState.variant === 'text' ? '6px 8px' : '6px 16px',
                    },
                    // MUI export sets default widths for the ripple effect, partly showing it when not interacting with the button
                    '&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover) .MuiTouchRipple-root': {
                        width: '0 !important',
                    },
                    ':hover': {
                        padding: ownerState.variant === 'text' ? '6px 8px' : '6px 16px',
                    },
                }),
                sizeSmall: ({ ownerState }) => ({
                    // Export bug causing variant outlined hover padding change
                    padding: ownerState.variant === 'text' ? '4px 5px' : '4px 10px',
                    '&.Mui-disabled': {
                        padding: ownerState.variant === 'text' ? '4px 5px' : '4px 10px',
                    },
                    // MUI export sets default widths for the ripple effect, partly showing it when not interacting with the button
                    '&:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover) .MuiTouchRipple-root': {
                        width: '0 !important',
                    },
                    ':hover': {
                        padding: ownerState.variant === 'text' ? '4px 5px' : '4px 10px',
                    },
                }),
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: ({ theme }) => ({
                    '&:-webkit-autofill': {
                        '-webkit-box-shadow': 'initial!important',
                        '-webkit-text-fill-color': 'initial',
                        'caret-color': 'initial',
                        appearance: 'menulist-button',
                        backgroundImage: 'none !important',
                        backgroundColor: theme.palette.info.light,
                        color: theme.palette.text.primary,
                    },
                }),
                root: ({ theme }) => ({
                    '&:has(> input:-webkit-autofill)': {
                        backgroundColor: theme.palette.info.light,
                    },
                }),
            },
        },
    },
};
export const hcpJSON = fixThemeOptions(deepmerge(cssVarJson, customizations), {
    disableDarkMode: true,
});
export const hcp = extendTheme(hcpJSON);
export default hcp;
//# sourceMappingURL=data:application/json;base64,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